import React, { useCallback } from 'react';
import { OnboardingTemplate, showToast } from '@ideoz/ui';
import { useLandingPageFacade, authService, useAppDispatch, setShowOnboarding } from '@ideoz/core';
import { useWebNavigation } from '../hooks/useWebNavigation';
import { useAuthDialog } from '../hooks/useAuthDialog';

export default function Onboarding(): JSX.Element {
  const dispatch = useAppDispatch();
  
  // ========== Platform-Specific Implementations ==========
  const navigation = useWebNavigation();
  const authDialog = useAuthDialog();
  
  // Adapt authDialog to AuthFacade interface
  const auth = React.useMemo(() => ({
    isOpen: authDialog.isOpen,
    mode: authDialog.mode,
    isLoading: authDialog.isLoading,
    openLogin: authDialog.openLogin,
    openRegister: authDialog.openRegister,
    close: authDialog.closeDialog,
  }), [authDialog]);

  // ========== Shared Facade (100% Reusable) ==========
  const facade = useLandingPageFacade({
    navigation,
    auth,
    showToast,
  });

  // ========== Handle onboarding completion ==========
  // This callback is called when user submits message in Step3
  // Only mark onboarding as complete after user actually completes Step3
  const handleCompleteOnboarding = useCallback(async () => {
    try {
      await authService.updateOnboardingShown();
      console.log('Successfully updated onboarding shown flag after Step3 completion');
      dispatch(setShowOnboarding(false));
    } catch (error) {
      console.error('Failed to update onboarding shown flag:', error);
      // Continue anyway - don't block the user
    }
  }, [dispatch]);

  console.log('Onboarding page facade:', facade);

  return <OnboardingTemplate facade={facade} onCompleteOnboarding={handleCompleteOnboarding} />;
}
